import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import AlertError from "../../../../../common/components/alert_error"
import { Header } from "./components/header"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { useMemo } from "react"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import { PageTopBar, TwoSlotLayout } from "../../../../../common/components/page_top_bar"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal"
import { CadastroItemChecklistEntregaModal } from "./components/ChecklistEntregaItensCadastroModal"
import { useChecklistEntregaItensCadastroViewModel } from "../../viewModels/checklist_entrega_itens_cadastro_view_model"
import { GenerateItemChecklistEntregaColumns } from "./columns/itens_checkist_collumn"
import { ItemChecklistEntrega } from "../../../domain/models/item_checklist_entrega"
import { BackButton } from "../../../../../common/components/back_button"
import { Link as LinkTo } from "react-router";

export const ChecklistEntregaItensCadastro = () => {
    const viewModel = useChecklistEntregaItensCadastroViewModel();

    const columnsDef = useMemo(() => {
        return GenerateItemChecklistEntregaColumns({
            onActionEdit: viewModel.handleEditChecklistEntregaItem,
            onActionDelete: viewModel.handleItemChecklistEntregaDeleteOpenState,
        });
    }, [
        viewModel.handleEditChecklistEntregaItem,
        viewModel.handleItemChecklistEntregaDeleteOpenState,
    ]);

    return (
        <>
            <PageTopBar>
                <TwoSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2 ">
                            <div className="w-[12rem]">
                                <PrimaryButton
                                    buttonColor="yellow"
                                    onClick={() => viewModel.handleItemChecklistEntregaDeleteOpenState(null, true)}>
                                    Excluir Selecionados
                                </PrimaryButton>
                            </div>
                            <div className="w-[220px]">
                                <PrimaryButton

                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleNewItemChecklistEntrega()}>
                                    Novo Item
                                </PrimaryButton>
                            </div>
                            <div>
                                <BackButton onClick={viewModel.handleBack} />
                            </div>
                        </div>
                    }
                />
            </PageTopBar>

            <div className="flex w-full gap-3 flex-col md:p-5 px-4 pt-8">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Home
                    </Link>
                    <Link underline="hover" color="inherit" component={"span"}>
                        <LinkTo to="/ChecklistEntrega_lista">Checklist de Entrega de Obras Lista</LinkTo>
                    </Link>
                    <Link underline="hover" color="inherit" component={"span"}>
                        <LinkTo to={`/ChecklistEntregaAmbiente_lista?id=${viewModel.selectedIdChecklistEntregaAmbiente}`}>Checklist de Entrega de Obras Ambiente Lista</LinkTo>
                    </Link>
                    <Typography className="text-primary-green">
                        Itens Checklist de Entrega de Obras
                    </Typography>
                </Breadcrumbs>
                <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        <h1 className="text-3xl font-medium text-black dark:text-white"> Checklist de Entrega de Obras</h1>
                        <p>Cadastro de Itens</p>
                        <RefreshButton onClick={viewModel.handleReload} />
                    </div>
                </div>
                <div className="grid grid-cols-1 gap-2">
                    <div className="flex flex-row text-black dark:text-white items-center">
                        <span className="font-extrabold text-xl mr-2">Checklist: </span>
                        <span className="mx-1 font-base text-base"> {(viewModel.checklistEntrega?.codigo + ' - ' + viewModel.checklistEntrega?.descricao) || '-'}
                        </span>
                    </div>
                    <div className="flex flex-row text-black dark:text-white items-center">
                        <span className="font-extrabold text-xl mr-2">Ambiente: </span>
                        <span className="mx-1 font-base text-base">{(viewModel.checklistEntregaAmbiente?.ordem + ' - ' + viewModel.checklistEntregaAmbiente?.descricao) || '-'}
                        </span>
                    </div>
                </div>
                {
                    viewModel.errorMessage !== undefined ? (
                        <div className="w-full">
                            <AlertError
                                messageErro={viewModel.errorMessage}
                                onTryAgain={viewModel.handleReload} />
                        </div>
                    ) : (
                        <>
                            <Header
                                ordem={viewModel.itensFilters.ordem ?? ''}
                                descricao={viewModel.itensFilters.descricao ?? ''}
                                handleOrdemChange={viewModel.handleItemOrdemChange}
                                handleDescricaoChange={viewModel.handleItemDescricaoChange}
                                onClearFilters={viewModel.handleItemClearFilters}
                            />

                            <div className="w-full " >
                                <Stack spacing={0}>

                                    <TablePagination
                                        component="div"
                                        count={viewModel.pagination.totalItems}
                                        page={viewModel.pagination.page - 1}
                                        onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                        rowsPerPageOptions={[10, 25, 50, 100]}
                                        rowsPerPage={viewModel.pagination.rowsPerPage}
                                        onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                    />

                                    <StyledDataGrid
                                        tableName="ItemChecklistEntrega_Lista"
                                        disableColumnMenu={false}
                                        showToolbar={true}
                                        disableRowSelectionOnClick={true}
                                        getRowId={(row: ItemChecklistEntrega) => row.idItemChecklistEntrega}
                                        columns={columnsDef}
                                        loading={viewModel.loading}
                                        checkboxSelection={true}
                                        rows={viewModel.itemChecklistEntregaLista}
                                        rowCount={viewModel.itemChecklistEntregaLista.length}

                                        onRowSelectionModelChange={viewModel.handleRowSelectionModelChange}
                                        rowSelectionModel={viewModel.rowSelectionModel}
                                        getRowHeight={() => 'auto'}
                                        pageSizeOptions={[10, 25, 50, 100]}
                                        paginationMode="server"
                                        paginationModel={{
                                            page: viewModel.pagination.page - 1,
                                            pageSize: viewModel.pagination.rowsPerPage,
                                        }}
                                        pinnedColumns={{
                                            right: ['idItemChecklistEntrega'],
                                        }}
                                    />

                                    <TablePagination
                                        component="div"
                                        count={viewModel.pagination.totalItems}
                                        page={viewModel.pagination.page - 1}
                                        onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                        rowsPerPageOptions={[10, 25, 50, 100]}
                                        rowsPerPage={viewModel.pagination.rowsPerPage}
                                        onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                    />

                                </Stack>
                            </div>
                        </>
                    )
                }
            </div >

            {/* delete item checklist entrega */}
            <DeleteDialog
                open={viewModel.openDeleteItemModal}
                onClose={() => viewModel.handleItemChecklistEntregaDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir este item?`}
                onDelete={viewModel.handleConfirmarDeletarItemChecklistEntrega}
            />

            <CadastroItemChecklistEntregaModal
                open={viewModel.openCadastroItemModal}
                saving={viewModel.saving}
                loading={viewModel.loading}
                hookFormCadastro={viewModel.hookForm}
                selectedItemChecklistEntrega={viewModel.selectedItemChecklistEntrega}
                handleNewItemChecklistEntrega={viewModel.handleNewItemChecklistEntrega}
                handleOpenChangeHistory={viewModel.handleOpenChangeHistory}
                onClose={() => viewModel.handleItemChecklistEntregaOpenState(null, false)}
                onSubmit={viewModel.handleSubmitItemChecklistEntrega}
            />

            <ChangeHistoryModal
                changeHistoryHandler={viewModel.changeHistory} />

        </>
    )
}
